// The caller's notification preferences (`notifications.prefs`): one cache entry per company,
// shared by Account › Notifications and the per-item Notify menus (INBOX-PREFS).
import { queryOptions } from "@tanstack/react-query";
import type { Api } from "../../api/client";

export const notificationKeys = {
  prefs: (co: string) => ["company", co, "notification-prefs"] as const,
  /** DE-REPLY-STYLE: the caller's reply length (`replyStyle.get`). */
  replyStyle: (co: string) => ["company", co, "reply-style"] as const,
};

export const notificationPrefsQuery = (api: Api, co: string) =>
  queryOptions({
    queryKey: notificationKeys.prefs(co),
    queryFn: () => api.client.notifications.prefs({ params: { co } }),
  });
